 <ng-template #content><ng-content></ng-content></ng-template>

  <button
    class="ctrl work-shift__cell"
    [ngbPopover]="cellPopContent"
    id="{{'appOpenEditCell' + cell.workday + '-' + user.u_id}}"
    *ngIf="!isPreviewCell"
    [ngClass]="{
                'work-shift__cell--plus': !cellPopoverIsOpen,
                'work-shift__cell--active': cellPopoverIsOpen,
                'work-shift__cell--disabled':
                templateFilter.isActiveTemplateFilterPreviewMode || templateFilter.isActiveTemplateFilter || cell.relocation,
                'work-shift__cell--plus--grs': isGRS
            }"
  autoClose="outside"
  placement="{{index > endIndex - 4 ? 'bottom-right' : 'bottom'}}"
  triggers="manual"
  #popover="ngbPopover"
  popoverClass="popover--w-350"
  (click)="onOpenEditConfirmDialog.emit(popover)"
  (shown)="showCell.emit()"
  (hidden)="hideCell.emit()"
  title="{{title}}"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
<button
  class="ctrl work-shift__cell"
  [ngbPopover]="cellPrevPopContent"
  id="{{'appOpenPrevCell' + cell.workday + '-' + user.u_id}}"
  *ngIf="isPreviewCell"
  [ngClass]="{
                'work-shift__cell--plus': !cellPopoverIsOpen,
                'work-shift__cell--active': cellPopoverIsOpen,
                'work-shift__cell--disabled':
                templateFilter.isActiveTemplateFilterPreviewMode || templateFilter.isActiveTemplateFilter || cell.relocation,
                'work-shift__cell--plus--grs': isGRS
            }"
  autoClose='outside'
  placement="{{index > endIndex - 6 ? 'bottom-right' : 'bottom'}}"
  triggers="manual"
  #popover="ngbPopover"
  (click)="onOpenEditConfirmDialog.emit(popover)"
  (shown)="showCell.emit()"
  (hidden)="hideCell.emit()"
  title="{{title}}"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
